module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/coursefinder-pathways-01e781677b1779664f00b5a13184e488.svg";